import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import FormModal from '../../Modals/FormModal';
import AddProductForm from '../../purchases/common/AddProductForm';
import EditBasicProductForm from '../../purchases/common/EditBasicProductForm';
import RecordTable from '../../Tables/record/RecordTable';
import PurchaseInfoCard from '../common/PurchaseInfoCard';
import PaymentConditionSection from '../common/PaymentConditionSection';
import { useTaxCreditPurchase } from '../../../hooks/purchases/useTaxCreditPurchase';
import { useSupplier } from '../../../hooks/useSupplier';
import {
  openAddProductModal,
  closeAddProductModal,
  openEditProductModal,
  closeEditProductModal,
  setProductToEdit,
} from '../../../store/slices/purchases/taxCreditPurchaseSlice';
import { RootState } from '../../../store/store';
import { useProduct } from '../../../hooks/useProduct';
import { taxCreditProductColumns } from '../../../features/purchases/taxcredit/taxCreditProductColumns';
import SvgIcon from '../../SvgIcon/SvgIcon';
import ProductSettlementModal from '../settlement/ProductSettlementModal';
import GeneralProductSettlementModal from '../settlement/GeneralProductSettlementModal';
import { useProductSettlement } from '../../../hooks/settlement/useProductSettlement';

const TaxCreditProductSection = () => {
  const dispatch = useDispatch();
  const {
    handlerAddProduct,
    handlerUpdateProduct,
    handlerDeleteProduct,
    handlerGetProductById,
    handlerRecalculateTotals,
    productToEdit,
    showAddProductModal,
    showEditProductModal,
  } = useTaxCreditPurchase();

  const { productsDropdown, handlerGetProductsForDropdownByItemType } =
    useProduct();

    console.log(productsDropdown);

  const { form, purchaseSettlementLoaded } = useSelector(
    (state: RootState) => state.basePurchase
  );
  const { suppliersDropdown, handlerGetSuppliersForDropdown } = useSupplier();

  useEffect(() => {
    handlerGetSuppliersForDropdown();
    handlerGetProductsForDropdownByItemType(1);
  }, []);

  const columns = useMemo(() => taxCreditProductColumns, []);

  const {
    handlerGetSettlementsByProduct,
    showGeneralSettlementModal,
    showSettlementModal,
    handlerOpenGeneralModal,
    handlerCloseGeneralModal,
    handlerCloseSettlementModal,
  } = useProductSettlement();

  const actions = useMemo(() => {
    if (purchaseSettlementLoaded) {
      return [
        {
          key: 'settle',
          onClick: (row: any) => {
            handlerGetSettlementsByProduct(form.id, row.id);
          },
        },
      ];
    }

    return [
      {
        key: 'edit',
        onClick: async (row: any) => {
          const product = await handlerGetProductById(row.id);
          if (product) {
            dispatch(setProductToEdit(product));
            dispatch(openEditProductModal());
          }
        },
      },
      {
        key: 'delete',
        onClick: (row: any) => {
          handlerDeleteProduct(row.id);
        },
      },
    ];
  }, [
    dispatch,
    handlerGetProductById,
    handlerDeleteProduct,
    purchaseSettlementLoaded,
  ]);

  return (
    <div className="mt-6">
      <PurchaseInfoCard
        title="Compra de Crédito Fiscal"
        suppliers={suppliersDropdown}
        maxWidth="w-full"
      />

      <RecordTable
        maxWidth="w-full"
        columns={columns}
        data={form.products}
        actions={actions}
        noDataMessage="No hay productos agregados."
        tableHeaderContent={
          <h3 className="text-lg font-medium">Productos del Crédito Fiscal</h3>
        }
        tableHeaderActions={
          purchaseSettlementLoaded ? (
            <button
              onClick={handlerOpenGeneralModal}
              className="flex items-center justify-center gap-2 rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90"
            >
              <SvgIcon name="settle-products" />
              Asentar General
            </button>
          ) : (
            <div className="flex items-center gap-2">
              {form.id && (
                <button
                  type="button"
                  onClick={() => handlerRecalculateTotals(form.id)}
                  title="Vuelve a calcular los totales (incluido IVA Percibido) leyendo la categoría actual del proveedor, sin modificar los productos."
                  className="flex items-center justify-center gap-2 rounded border border-primary px-4.5 py-2.5 font-medium text-primary hover:bg-primary hover:bg-opacity-10"
                >
                  <SvgIcon name="refresh" />
                  Recalcular
                </button>
              )}
              <button
                onClick={() => dispatch(openAddProductModal())}
                className="flex items-center justify-center gap-2 rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90"
              >
                <SvgIcon name="plus" />
                Agregar Producto
              </button>
            </div>
          )
        }
      />

      {/* Modal Registro */}
      <FormModal
        isOpen={showAddProductModal}
        onClose={() => dispatch(closeAddProductModal())}
        title="Agregar Producto"
        maxWidth="max-w-4xl"
      >
        <AddProductForm
          onAdd={handlerAddProduct}
          productOptions={productsDropdown}
        />
      </FormModal>

      {/* Modal Edición */}
      <FormModal
        isOpen={showEditProductModal}
        onClose={() => dispatch(closeEditProductModal())}
        title="Editar Producto"
        maxWidth="max-w-4xl"
      >
        {productToEdit && (
          <EditBasicProductForm
            productToEdit={productToEdit}
            productOptions={productsDropdown}
            onUpdate={handlerUpdateProduct}
            onClose={() => dispatch(closeEditProductModal())}
          />
        )}
      </FormModal>

      <PaymentConditionSection />

      <ProductSettlementModal
        isOpen={showSettlementModal}
        onClose={handlerCloseSettlementModal}
      />

      <GeneralProductSettlementModal
        isOpen={showGeneralSettlementModal}
        onClose={handlerCloseGeneralModal}
      />
    </div>
  );
};

export default TaxCreditProductSection;
